import * as React from 'react';

function ARIconBig(props) {
    return (
        <svg
            width={87}
            height={99}
            viewBox="0 0 87 99"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M55.212 11.28c-.426 0-.71-.143-.994-.285L43.43 4.737 32.5 10.995c-.995.569-2.272.284-2.84-.711-.568-.996-.284-2.276.71-2.845L42.294.613a1.703 1.703 0 011.987 0l11.925 6.826c.994.57 1.277 1.85.71 2.845-.284.569-.852.995-1.704.995z"
                fill="url(#prefix__paint0_linear)"
            />
            <path
                d="M43.43 65.184c-1.136 0-1.988-.853-1.988-1.991V49.397c0-1.138.852-1.991 1.987-1.991 1.136 0 1.988.853 1.988 1.991v13.654c0 1.28-.852 2.133-1.988 2.133z"
                fill="url(#prefix__paint1_linear)"
            />
            <path
                d="M2.686 41.572c-1.136 0-1.988-.853-1.988-1.99V25.784c0-1.137.852-1.99 1.988-1.99 1.136 0 1.987.853 1.987 1.99v13.796c0 1.138-.851 1.991-1.987 1.991z"
                fill="url(#prefix__paint2_linear)"
            />
            <path
                d="M84.172 41.572c-1.136 0-1.987-.853-1.987-1.99V25.784c0-1.137.851-1.99 1.987-1.99 1.136 0 1.987.853 1.987 1.99v13.796c0 1.138-.851 1.991-1.987 1.991z"
                fill="url(#prefix__paint3_linear)"
            />
            <path
                d="M84.172 75.14c-1.136 0-1.987-.853-1.987-1.99V59.352c0-1.138.851-1.99 1.987-1.99 1.136 0 1.987.852 1.987 1.99V73.15c0 1.138-.851 1.991-1.987 1.991z"
                fill="url(#prefix__paint4_linear)"
            />
            <path
                d="M2.686 75.14c-1.136 0-1.988-.853-1.988-1.99V59.352c0-1.138.852-1.99 1.988-1.99 1.136 0 1.987.852 1.987 1.99V73.15c0 1.138-.851 1.991-1.987 1.991z"
                fill="url(#prefix__paint5_linear)"
            />
            <path
                d="M43.43 19.387c-1.136 0-1.988-.854-1.988-1.991V2.319c0-1.138.852-1.991 1.987-1.991 1.136 0 1.988.853 1.988 1.991v14.934c0 1.138-.852 2.134-1.988 2.134z"
                fill="url(#prefix__paint6_linear)"
            />
            <path
                d="M43.43 98.75c-1.136 0-1.988-.853-1.988-1.991V83.105c0-1.138.852-1.991 1.987-1.991 1.136 0 1.988.853 1.988 1.991v13.796c0 .853-.852 1.849-1.988 1.849z"
                fill="url(#prefix__paint7_linear)"
            />
            <path
                d="M43.428 98.748c-.426 0-.71-.142-.994-.284L30.51 91.637c-.994-.569-1.278-1.849-.71-2.844.567-.996 1.845-1.28 2.839-.712l10.93 6.258 10.79-6.258c.994-.426 2.271.143 2.555 1.28.284.854 0 1.707-.568 2.276l-11.782 6.827c-.426.142-.71.284-1.136.284z"
                fill="url(#prefix__paint8_linear)"
            />
            <path
                d="M43.428 51.532c-.426 0-.71-.142-.994-.284l-11.924-6.97c-.994-.568-1.278-1.848-.71-2.844.567-.995 1.845-1.28 2.839-.711l10.93 6.258 10.79-6.258c.994-.569 2.271-.142 2.697.853.426.996.142 2.134-.71 2.703l-11.924 6.826c-.284.285-.71.427-.994.427z"
                fill="url(#prefix__paint9_linear)"
            />
            <path
                d="M72.247 34.746c-1.135 0-1.987-.854-1.987-1.991 0-.712.426-1.423.993-1.85l11.925-6.826c.994-.569 2.272-.284 2.84.711.567.996.283 2.276-.71 2.845L73.383 34.46c-.426.285-.71.285-1.136.285z"
                fill="url(#prefix__paint10_linear)"
            />
            <path
                d="M84.172 27.918c-.426 0-.71-.142-.994-.284l-11.925-6.827c-.994-.569-1.278-1.849-.71-2.844.568-.996 1.846-1.28 2.84-.711l11.924 6.826c.994.57 1.278 1.85.71 2.845-.426.569-1.135.995-1.845.995z"
                fill="url(#prefix__paint11_linear)"
            />
            <path
                d="M14.61 34.748c-.425 0-.71-.142-.993-.284l-11.925-6.97c-.994-.568-1.278-1.848-.71-2.844.568-.995 1.846-1.28 2.84-.71l11.924 6.826c.994.569 1.278 1.849.71 2.844-.426.712-1.136 1.138-1.845 1.138z"
                fill="url(#prefix__paint12_linear)"
            />
            <path
                d="M2.686 27.918c-1.136 0-1.988-.853-1.988-1.99 0-.712.426-1.423.994-1.85l11.783-6.826c.994-.57 2.271-.285 2.84.71.567.996.283 2.276-.71 2.845L3.678 27.634c-.283.142-.71.284-.993.284z"
                fill="url(#prefix__paint13_linear)"
            />
            <path
                d="M72.247 81.965c-1.135 0-1.987-.854-1.987-1.992 0-.71.426-1.422.993-1.849l11.925-6.826c.994-.57 2.272-.285 2.84.71.567.996.283 2.276-.71 2.845L73.383 81.68c-.426.142-.852.284-1.136.284z"
                fill="url(#prefix__paint14_linear)"
            />
            <path
                d="M84.172 75.142c-.426 0-.71-.142-.994-.285l-11.925-6.826c-.994-.57-1.278-1.85-.71-2.845.568-.996 1.846-1.28 2.84-.711l11.924 6.827c.994.569 1.278 1.849.71 2.844-.426.57-1.135.996-1.845.996z"
                fill="url(#prefix__paint15_linear)"
            />
            <path
                d="M14.61 81.965c-.425 0-.71-.143-.993-.285L1.692 74.853c-.994-.569-1.278-1.849-.71-2.844.568-.996 1.846-1.28 2.84-.712l11.924 6.827c.994.57 1.278 1.85.71 2.845-.568.569-1.136.996-1.845.996z"
                fill="url(#prefix__paint16_linear)"
            />
            <path
                d="M2.686 75.141c-1.136 0-1.988-.853-1.988-1.99 0-.712.426-1.423.994-1.85l11.783-6.826c.994-.57 2.271-.285 2.84.71.567.996.283 2.276-.71 2.845L3.82 74.857c-.425.142-.851.284-1.135.284z"
                fill="url(#prefix__paint17_linear)"
            />
            <path
                opacity={0.2}
                d="M2.686 27.068c-.71 0-1.135-.569-1.135-1.138 0-.426.284-.853.568-.995L42.862 1.326c.567-.284 1.277-.142 1.561.427.284.569.142 1.28-.426 1.564L3.254 26.927c-.142 0-.426.141-.568.141z"
                fill="url(#prefix__paint18_linear)"
            />
            <path
                opacity={0.2}
                d="M84.17 27.068c-.141 0-.425 0-.567-.142L42.86 3.317c-.568-.284-.71-.995-.426-1.564.284-.57.994-.711 1.562-.427l40.743 23.609c.568.284.71.995.426 1.564-.284.285-.568.57-.994.57z"
                fill="url(#prefix__paint19_linear)"
            />
            <path
                opacity={0.2}
                d="M84.172 74.143c-.142 0-.426 0-.568-.142L2.12 26.924c-.568-.285-.71-.996-.426-1.565s.993-.71 1.561-.426L84.74 72.152c.568.284.71.995.426 1.564-.284.285-.568.427-.994.427z"
                fill="url(#prefix__paint20_linear)"
            />
            <path
                opacity={0.2}
                d="M43.43 97.896c-.142 0-.426 0-.568-.142L2.119 74.002c-.568-.285-.71-.996-.426-1.565s.993-.71 1.561-.426l40.743 23.61c.568.284.71.995.426 1.564a1.068 1.068 0 01-.994.71z"
                fill="url(#prefix__paint21_linear)"
            />
            <path
                opacity={0.2}
                d="M43.428 97.894c-.71 0-1.136-.57-1.136-1.138 0-.427.284-.853.568-.996l40.743-23.61c.568-.284 1.278-.141 1.562.427.283.57.142 1.28-.426 1.565l-40.743 23.61c-.142 0-.426.142-.568.142z"
                fill="url(#prefix__paint22_linear)"
            />
            <path
                opacity={0.2}
                d="M2.686 74.146c-.567 0-1.135-.57-1.135-1.138v-47.22c0-.711.568-1.138 1.135-1.138.71 0 1.136.57 1.136 1.138v47.22c0 .711-.426 1.28-1.136 1.138z"
                fill="url(#prefix__paint23_linear)"
            />
            <path
                opacity={0.2}
                d="M84.172 74.146c-.71 0-1.136-.57-1.136-1.138v-47.22c0-.711.568-1.138 1.136-1.138s1.136.57 1.136 1.138v47.22c0 .711-.568 1.28-1.136 1.138z"
                fill="url(#prefix__paint24_linear)"
            />
            <path
                opacity={0.2}
                d="M43.428 97.755c-.71 0-1.136-.569-1.136-1.137V2.322c0-.711.568-1.138 1.136-1.138.71 0 1.136.569 1.136 1.138v94.153c0 .712-.568 1.28-1.136 1.28z"
                fill="url(#prefix__paint25_linear)"
            />
            <defs>
                <linearGradient
                    id="prefix__paint0_linear"
                    x1={43.287}
                    y1={0.293}
                    x2={43.287}
                    y2={11.285}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint1_linear"
                    x1={43.429}
                    y1={47.406}
                    x2={43.429}
                    y2={65.184}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint2_linear"
                    x1={2.686}
                    y1={23.794}
                    x2={2.686}
                    y2={41.572}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint3_linear"
                    x1={84.172}
                    y1={23.794}
                    x2={84.172}
                    y2={41.572}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint4_linear"
                    x1={84.172}
                    y1={57.362}
                    x2={84.172}
                    y2={75.14}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint5_linear"
                    x1={2.686}
                    y1={57.362}
                    x2={2.686}
                    y2={75.14}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint6_linear"
                    x1={43.429}
                    y1={0.328}
                    x2={43.429}
                    y2={19.387}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint7_linear"
                    x1={43.429}
                    y1={81.114}
                    x2={43.429}
                    y2={98.75}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint8_linear"
                    x1={43.268}
                    y1={87.791}
                    x2={43.268}
                    y2={98.748}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint9_linear"
                    x1={43.381}
                    y1={40.433}
                    x2={43.381}
                    y2={51.532}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint10_linear"
                    x1={78.283}
                    y1={23.789}
                    x2={78.283}
                    y2={34.746}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint11_linear"
                    x1={78.28}
                    y1={16.962}
                    x2={78.28}
                    y2={27.918}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint12_linear"
                    x1={8.719}
                    y1={23.649}
                    x2={8.719}
                    y2={34.748}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint13_linear"
                    x1={8.651}
                    y1={16.962}
                    x2={8.651}
                    y2={27.918}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint14_linear"
                    x1={78.283}
                    y1={71.007}
                    x2={78.283}
                    y2={81.965}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint15_linear"
                    x1={78.28}
                    y1={64.185}
                    x2={78.28}
                    y2={75.142}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint16_linear"
                    x1={8.719}
                    y1={71.007}
                    x2={8.719}
                    y2={81.965}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint17_linear"
                    x1={8.651}
                    y1={64.185}
                    x2={8.651}
                    y2={75.141}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint18_linear"
                    x1={23.058}
                    y1={1.184}
                    x2={23.058}
                    y2={27.068}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint19_linear"
                    x1={63.8}
                    y1={1.184}
                    x2={63.8}
                    y2={27.068}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint20_linear"
                    x1={43.429}
                    y1={24.791}
                    x2={43.429}
                    y2={74.143}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint21_linear"
                    x1={23.058}
                    y1={71.868}
                    x2={23.058}
                    y2={97.896}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint22_linear"
                    x1={63.8}
                    y1={72.009}
                    x2={63.8}
                    y2={97.894}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint23_linear"
                    x1={2.686}
                    y1={24.65}
                    x2={2.686}
                    y2={74.168}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint24_linear"
                    x1={84.172}
                    y1={24.65}
                    x2={84.172}
                    y2={74.168}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
                <linearGradient
                    id="prefix__paint25_linear"
                    x1={43.428}
                    y1={1.184}
                    x2={43.428}
                    y2={97.755}
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#34D2E4" />
                    <stop offset={1} stopColor="#0091FB" />
                </linearGradient>
            </defs>
        </svg>
    );
}

export default ARIconBig;
